export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const FOCUS_AIRCRAFT = 'FOCUS_AIRCRAFT';
export const UNFOCUS_AIRCRAFT = 'UNFOCUS_AIRCRAFT';

export const FETCH_AIRCRAFT_SUCCESS = 'FETCH_AIRCRAFT_SUCCESS';
export const FETCH_AIRCRAFT_ERROR = 'FETCH_AIRCRAFT_ERROR';
export const FETCH_AIRCRAFT_PENDING = 'FETCH_AIRCRAFT_PENDING';

export const FETCH_ALL_AIRCRAFT_SUCCESS = 'FETCH_ALL_AIRCRAFT_SUCCESS';
export const FETCH_ALL_AIRCRAFT_ERROR = 'FETCH_ALL_AIRCRAFT_ERROR';
export const FETCH_ALL_AIRCRAFT_PENDING = 'FETCH_ALL_AIRCRAFT_PENDING';

export const TOGGLE_FIRS = 'TOGGLE_FIRS';
export const TOGGLE_COLOR_MODE = 'TOGGLE_COLOR_MODE';
export const TOGGLE_AIRPORT_MARKER = 'TOGGLE_AIRPORT_MARKER';
export const TOGGLE_AIRPORT_MARKER_ATC_BADGES = 'TOGGLE_AIRPORT_MARKER_ATC_BADGES';
export const TOGGLE_AIRPORT_MARKER_APPROACH_CIRCLE = 'TOGGLE_AIRPORT_MARKER_APPROACH_CIRCLE';